import { render, staticRenderFns } from "./ProfileSummary.vue?vue&type=template&id=da15a99e&scoped=true"
import script from "./ProfileSummary.vue?vue&type=script&lang=js"
export * from "./ProfileSummary.vue?vue&type=script&lang=js"
import style0 from "./ProfileSummary.vue?vue&type=style&index=0&id=da15a99e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da15a99e",
  null
  
)

export default component.exports